// Guest wishlist persisted to localStorage. A future logged-in wishlist API
// can replace this without touching the call sites - same shape.
const KEY = 'itec_wishlist';

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function write(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
    // Notify same-tab listeners so the header counter etc. update.
    window.dispatchEvent(new CustomEvent('wishlist:changed'));
  } catch {
    // ignore
  }
}

export function getWishlist() {
  return read();
}

export function isInWishlist(productId) {
  return read().some((p) => p.id === productId);
}

// Snapshot only the fields the wishlist UI needs — never internal data.
function toStored(product) {
  return {
    id: product.id,
    slug: product.slug,
    name: product.name,
    mainImage: product.image || product.main_image_url || null,
    brand: product.brand_name || product.brand?.name || null,
    priceVisibility: product.price_visibility || null,
    regularPrice: product.regular_price ?? null,
    salePrice: product.sale_price ?? null,
  };
}

export function addToWishlist(product) {
  if (!product?.id) return read();
  const list = read();
  if (list.some((p) => p.id === product.id)) return list;
  const next = [...list, toStored(product)];
  write(next);
  return next;
}

export function removeFromWishlist(productId) {
  const next = read().filter((p) => p.id !== productId);
  write(next);
  return next;
}

export function clearWishlist() {
  write([]);
}

export const WISHLIST_EVENT = 'wishlist:changed';
